import { type FC, type ReactNode } from "react";

import { Alert, Spinner, Status } from "@snapchat/snap-design-system";

import { PayoutDataError } from "../../../../lens-creator-payout/components/messages.generated";

interface PanelDataGuardProps {
    loading: boolean;
    error?: Error;
    children: ReactNode;
}

export const PanelDataGuard: FC<PanelDataGuardProps> = ({ loading, error, children }) => {
    if (loading) {
        return <Spinner />;
    }
    if (error) {
        return <Alert status={Status.ERROR} title={<PayoutDataError />} />;
    }
    return <>{children}</>;
};
